export function initColorInputs() {
    document.querySelectorAll('.color-input').forEach(container => {
        const resetButton = container.querySelector<HTMLButtonElement>('.reset-button > button');
        const colorInput = container.querySelector<HTMLInputElement>('input[type=color]');
        const textInput = container.querySelector<HTMLInputElement>('input[type=text]');
        const defaultValue = colorInput.dataset.default ?? '';
        const toggleResetButton = () => {
            if (resetButton && defaultValue) {
                if (colorInput.value === defaultValue) {
                    resetButton.parentElement.classList.add('hidden')
                } else {
                    resetButton.parentElement.classList.remove('hidden');
                }
            }
        };

        if (resetButton && colorInput) {
            resetButton.addEventListener('click', () => {
                colorInput.value = defaultValue;

                if (textInput) {
                    colorInput.dispatchEvent(new Event('change'))
                }
            });
        }

        if (textInput && colorInput) {
            colorInput.addEventListener('input', () => {
                textInput.value = colorInput.value;
            });
            colorInput.addEventListener('change', () => {
                textInput.value = colorInput.value;
                toggleResetButton();                
            });
            textInput.addEventListener('change', () => {
                colorInput.value = textInput.value;
                toggleResetButton();                
            });
            textInput.addEventListener('input', () => {
                colorInput.value = textInput.value;
                toggleResetButton();                
            });
        }
    });
}